import React, { Component } from 'react';

class FooterLinks extends Component {
    render() {
        return (
            <React.Fragment>
        <div className="footer-alt bg-dark">
            <p className="copy-rights"> 2021 © EA Solutions, LLC. All rights reserved.</p>
        </div>
            </React.Fragment>
        );
    }
}

export default FooterLinks;